import ShUserAvatar from '@/components/Helpers/ShUserAvatar';

// @vue/component
export default {
  name: 'AgentSignature',

  components: {
    ShUserAvatar,
  },

  props: {
    agent: {
      required: true,
      type: Object,
      default: () => ({}),
    },
    canSetActive: {
      type: Boolean,
      default: false,
    },
  },
};
